module.exports = __webpack_public_path__ + "img/dark-main-demo.8cdac987.png";